export default __webpack_public_path__ + "static/media/tg.b62a05e7.png";